(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('DistributionMonitoringController', distributionMonitoring);

  distributionMonitoring.$inject = ['$rootScope', 'socketConnect', 'DashboardService', 'SectorService', 'NotificationService', 'socket'];

  function distributionMonitoring ($rootScope, socketConnect, DashboardService, SectorService, NotificationService, socket) {
    var vmDistributionMonitoringCtrl = this;
    vmDistributionMonitoringCtrl.filters = {
      days: null,
      sector: null,
      operator: null,
      channel: null
    }

    function loadCounters () {
      DashboardService.loadCounters()
        .$promise
        .then(function (data) {
          showDashboard(data);
          setTimeout(function () {
            loadCounters();
          }, 60000);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao carregar operadores.');
        });
    }

    function showDashboard (obj) {
      if (!vmDistributionMonitoringCtrl.lock && obj) {
        vmDistributionMonitoringCtrl.operators = obj.operators;
        vmDistributionMonitoringCtrl.setCounters(obj.counters);
        vmDistributionMonitoringCtrl.setOperators(obj.operators_counters);
        vmDistributionMonitoringCtrl.getDashboardByOperador();
      }
    }

    vmDistributionMonitoringCtrl.setCounters = function (counters) {
      vmDistributionMonitoringCtrl.original_counters = angular.copy(counters);
      vmDistributionMonitoringCtrl.counters = counters;
    }

    vmDistributionMonitoringCtrl.setOperators = function (operators_counters) {
      vmDistributionMonitoringCtrl.original_operators_counters = angular.copy(operators_counters);
      vmDistributionMonitoringCtrl.operators_counters = operators_counters;
    }

    vmDistributionMonitoringCtrl.getDashboardByOperador = function () {
      if (vmDistributionMonitoringCtrl.filters.operator) {
        const operatorSelected = getCountersByOperator(vmDistributionMonitoringCtrl.filters.operator);
        vmDistributionMonitoringCtrl.operators_counters = filterOperators(vmDistributionMonitoringCtrl.filters.operator)
        updateCountersWithOperators(operatorSelected);
      } else {
        vmDistributionMonitoringCtrl.counters = angular.copy(vmDistributionMonitoringCtrl.original_counters);
        restoreOperatorsCounters();
      }
    }

    function updateCountersWithOperators (operatorSelected) {
      vmDistributionMonitoringCtrl.counters = operatorSelected || {};
      vmDistributionMonitoringCtrl.counters['attended'] = operatorSelected ? operatorSelected.total : 0;
      vmDistributionMonitoringCtrl.counters['online'] = operatorSelected ? (operatorSelected.online ? 1 : 0) : 0;
      vmDistributionMonitoringCtrl.counters['offline'] = operatorSelected ? (operatorSelected.offline ? 1 : 0) : 0;
      vmDistributionMonitoringCtrl.counters['paused'] = operatorSelected ? (operatorSelected.paused ? 1 : 0) : 0;
      vmDistributionMonitoringCtrl.counters['full'] = operatorSelected ? (operatorSelected.full ? 1 : 0) : 0;
      vmDistributionMonitoringCtrl.counters['total'] = vmDistributionMonitoringCtrl.original_counters.total;
      vmDistributionMonitoringCtrl.counters['notDistributed'] = vmDistributionMonitoringCtrl.original_counters.notDistributed;
      vmDistributionMonitoringCtrl.counters['auto'] = vmDistributionMonitoringCtrl.original_counters.auto;
    }

    function getCountersByOperator (userId) {
      restoreOperatorsCounters();
      return vmDistributionMonitoringCtrl.operators_counters.find(operator => {
        return operator.userId === userId;
      })
    }

    function filterOperators (userId) {
      restoreOperatorsCounters();
      return vmDistributionMonitoringCtrl.operators_counters.filter(operator => {
        return operator.userId === userId;
      })
    }

    function restoreOperatorsCounters () {
      vmDistributionMonitoringCtrl.operators_counters = angular.copy(vmDistributionMonitoringCtrl.original_operators_counters);
    }

    vmDistributionMonitoringCtrl.refresh = function () {
      $state.reload();
    }

    vmDistributionMonitoringCtrl.calcTimes = function (tme) {
      var time = moment.duration(tme, 'seconds');
      var hours = time.hours() + (time.days() * 24);
      return (hours < 10 ? '0' + hours : hours) + 'h ' + (time.minutes() < 10 ? '0' + time.minutes() : time.minutes()) + 'm';
    }

    function socketDashboard () {
      socket.connect(socketDistributionDashboardUrl);
      socket.emit('authenticate', {
        'token': socketDistributionDashboardToken,
        'companyId': $rootScope.user_data.company_id
      });
      socket.on('update-dashboard', function (data) {
        if (data.ns.coll === 'company_monitoring') {
          vmDistributionMonitoringCtrl.setCounters(data.fullDocument);
        }

        if (data.ns.coll === 'pool_monitoring') {
          vmDistributionMonitoringCtrl.updateOperators(data.fullDocument);
        }
        vmDistributionMonitoringCtrl.getDashboardByOperador()
      });
    }

    vmDistributionMonitoringCtrl.updateOperators = function (operator) {
      if (Array.isArray(vmDistributionMonitoringCtrl.original_operators_counters)) {
        let isNewOperator = true;
        vmDistributionMonitoringCtrl.original_operators_counters.some((element, index, arr) => {
          if (element._id === operator._id) {
            isNewOperator = false;
            operator.name = element.name;
            arr[index] = operator;
            if (!operator.online && operator.total == 0) {
              arr.splice(index, 1);
            }
            vmDistributionMonitoringCtrl.setOperators(arr);
            return true;
          }

          if (index === arr.length - 1 && isNewOperator &&
                        (operator.online || (!operator.online && operator.total > 0))) {
            vmDistributionMonitoringCtrl.pushNewOperator(operator);
          }
        })

        if (vmDistributionMonitoringCtrl.original_operators_counters.length === 0 &&
                    (operator.online || (!operator.online && operator.total > 0))) {
          vmDistributionMonitoringCtrl.pushNewOperator(operator);
        }
      }
    }

    vmDistributionMonitoringCtrl.pushNewOperator = function (operator) {
      var user = vmDistributionMonitoringCtrl.operators.find(op => op.id == operator.userId);
      operator.name = user ? user.name : '';
      vmDistributionMonitoringCtrl.original_operators_counters.push(operator);
    }

    loadCounters();
    socketDashboard();
  }
})();
